import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the datatable for the deposit report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'Date', // Column ID
                    header: _('Fecha'), // Column header with localization
                    fillspace: 0, // Fill space setting
                    minWidth: 0, // Minimum width
                    width: 200, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format
                },
                { id: 'Hour', header: 'Hora', width: 200, sort: 'int' }, // Hour column
                {
                    id: 'NoTicket',
                    header: 'No. Ticket',
                    width: 150,
                    sort: 'int',
                }, // Ticket number column
                {
                    id: 'FormaPago1',
                    header: 'Forma Pago 1',
                    width: 150,
                    sort: 'int',
                }, // Payment method column
                {
                    id: 'PagoBonoTC',
                    header: 'Pago Bono / T.C.',
                    width: 150,
                    sort: 'int',
                }, // Bonus/TC payment column
                {
                    id: 'ValorEntradasEfectivo',
                    header: 'Valor Entradas Efectivo',
                    width: 200,
                    sort: 'int',
                }, // Cash entries value column
                {
                    id: 'ValorEntradasBonoTC',
                    header: 'Valor Entradas Bono / T.C.',
                    width: 200,
                    sort: 'int',
                }, // Bonus/TC entries value column
                {
                    id: 'ValorEntradasTraslados',
                    header: 'Valor Entradas Traslados',
                    width: 200,
                    sort: 'int',
                }, // Transfer entries value column
                {
                    id: 'ValorEntradasRecargas',
                    header: 'Valor Entradas Recargas',
                    width: 200,
                    sort: 'int',
                }, // Recharge entries value column
                {
                    id: 'ValorSalidasEfectivo',
                    header: 'Valor Salidas Efectivo',
                    width: 200,
                    sort: 'int',
                }, // Cash exits value column
                {
                    id: 'ValorSalidasTraslados',
                    header: 'Valor Salidas Traslados',
                    width: 200,
                    sort: 'int',
                }, // Transfer exits value column
                {
                    id: 'ValorSalidasNotasRetiro',
                    header: 'Valor Salidas Notas de Retiro',
                    width: 200,
                    sort: 'int',
                }, // Withdrawal notes exits value column
                { id: 'Saldo', header: 'Saldo', width: 150, sort: 'int' }, // Balance column
                { id: 'Moneda', header: 'Moneda', width: 150, sort: 'int' }, // Currency column
            ],
            footer: true, // Enable footer
            math: true, // Enable mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for data fetching
            url: devConfig.geturlApi() + 'es/GetFlujoCaja?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // Data URL
        var filter = ''; // Filter string

        // Event listener for filtering data
        this.on(this.app, 'flujoCaja:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string initialization

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player ID
            );
        });
    }
}

// FILE DOCUMENTED
